import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getSurvey, getSurveyByToken } from "api/cansurvey/surveyApi";

interface UseSurveyResult {
  surveyJson: any | null;
  loading: boolean;
  error: string | null;
  surveyId: string | null;
  token: string | null;
}

export const useSurvey = (): UseSurveyResult => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const surveyId = searchParams.get("surveyId");
  const [surveyJson, setSurveyJson] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token && !surveyId) {
      setError("No survey ID or token provided");
      setLoading(false);
      return;
    }

    const fetchSurvey = async () => {
      try {
        setLoading(true);
        setError(null);
        const surveyContent = token
          ? await getSurveyByToken(token)
          : await getSurvey(Number(surveyId));
        const parsedContent = JSON.parse(surveyContent);
        setSurveyJson(parsedContent);
      } catch (err) {
        const errorMessage =
          err instanceof Error ? err.message : "Failed to load survey";
        setError(errorMessage);
        setSurveyJson(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSurvey();
  }, [token, surveyId]);

  return {
    surveyJson,
    loading,
    error,
    surveyId,
    token,
  };
};
